/**
 * Accordion: whole row ([data-toggle-dropdown] on .menu-drawer__accordion-trigger) toggles the panel.
 * Avoids <button> so Dawn's MenuDrawer does not treat clicks as submenu close.
 */
(function () {
  function toggleAccordion(toggleEl, root) {
    const row = toggleEl.classList.contains('menu-drawer__accordion-trigger')
      ? toggleEl
      : toggleEl.closest('.menu-drawer__accordion-trigger');
    const item = toggleEl.closest('.navbar-links-main__item');
    const dropdown = row?.nextElementSibling;

    if (!item || !row || !dropdown || !dropdown.classList.contains('menu-drawer-mobile-dropdown')) return;

    const isActive = dropdown.classList.contains('active');

    root.querySelectorAll('.menu-drawer-mobile-dropdown.active').forEach((d) => {
      d.classList.remove('active');
      d.closest('.navbar-links-main__item')?.classList.remove('open');
      const prevRow = d.previousElementSibling;
      if (prevRow && prevRow.classList.contains('menu-drawer__accordion-trigger')) {
        prevRow.classList.remove('open');
        const prevToggle = prevRow.querySelector('[data-toggle-dropdown]');
        prevToggle?.setAttribute('aria-expanded', 'false');
      }
    });

    if (!isActive) {
      dropdown.classList.add('active');
      item.classList.add('open');
      row.classList.add('open');
      toggleEl.setAttribute('aria-expanded', 'true');
    } else {
      item.classList.remove('open');
      row.classList.remove('open');
      toggleEl.setAttribute('aria-expanded', 'false');
    }
  }

  function onActivate(event, root) {
    const toggleEl = event.target.closest('[data-toggle-dropdown]');
    if (!toggleEl || !root.contains(toggleEl)) return;

    if (event.target.closest('.nav-parent-link')) {
      event.preventDefault();
    }

    event.stopPropagation();
    toggleAccordion(toggleEl, root);
  }

  function init(root) {
    if (!root || root.dataset.accordionBound === 'true') return;
    root.dataset.accordionBound = 'true';

    root.addEventListener('click', (e) => onActivate(e, root));

    root.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const toggleEl = e.target.closest('[data-toggle-dropdown]');
      if (!toggleEl || !root.contains(toggleEl)) return;
      if (e.target.closest('.nav-parent-link')) e.preventDefault();
      e.preventDefault();
      toggleAccordion(toggleEl, root);
    });

    root.querySelectorAll('.menu-drawer-mobile-dropdown').forEach((dropdown) => {
      dropdown.addEventListener('click', (e) => e.stopPropagation());
    });
  }

  document.querySelectorAll('[data-menu-drawer-accordion]').forEach(init);
})();
